import { Component, Inject } from '@angular/core';
import { MmDialogData } from '@metromarkets/components';

import { IAddress } from '~shared/modules/addresses/models/address.model';

@Component({
  selector: 'app-remove-address-dialog',
  templateUrl: './remove-address-dialog.component.html',
  styleUrls: ['./remove-address-dialog.component.scss'],
})
export class RemoveAddressDialogComponent {
  public address: IAddress;

  constructor(
    @Inject(MmDialogData) public data: any,
  ) {
    this.address = data.address;
  }
}
